import EquipmentCard from './EquipmentCard';

export { default as EquipmentCardRecurrence } from './Recurrence/EquipmentCardRecurrence';

export default EquipmentCard;
